import { Tag } from 'antd'
import classnames from 'classnames'

import Styled from './styled'

export default function MyTag({ size, children, ...props }) {
  return (
    <Styled>
      <Tag className={classnames({ small: size === 'small' })} {...props}>
        {children}
      </Tag>
    </Styled>
  )
}
